import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { MAIN_DEFAULTS, TMainProps } from "@/ui/components/layout/Main";

export const Main: FC<TMainProps> = (
  {
    "data-component": component = MAIN_DEFAULTS["data-component"],
    id = MAIN_DEFAULTS.id,
    className,
    children,
    ...props
  },
) => (
  <main
    {...props}
    id={id}
    data-component={component}
    className={cn(
      className,
    )}
  >
    { children }
  </main>
);

Main.displayName = "Main";
